export default {
	first: "",
	last: "",
	email: "",
	properties: "",
	builders: [],
	notes: "",
	modules: {},
	password: "",
	status: "",
	neighborhoods: [],
	builder_portal: "",
	lot_types: [],
	manager_email: '',
	manager_paperwork: '',
	manager_email_leads: '',
	disable_reminders: ''
}